var _path, _path2, _path3, _path4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupImgResponsive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 753,
    viewBox: "0 0 351 753",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 359.927C38.2743 394.639 88.2827 414 140.297 414L348 414L348 206.962C348 152.072 326.09 99.4305 287.09 60.6177C248.089 21.8049 195.194 -4.08328e-05 140.039 -4.80316e-05L0 -6.63094e-05V359.927Z",
    fill: "#AADCB9",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M344 624.817L344 497L215.476 497C181.402 497 148.724 510.483 124.63 534.483C100.536 558.484 87 591.035 87 624.976L87 753L215.317 753C249.446 753 282.177 739.495 306.309 715.456C330.442 691.417 344 658.813 344 624.817H344Z",
    fill: "#AADCB9",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115 208H350.5",
    stroke: "#8DCF9F",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113 201.967H110.001L106.86 205.298H93.1479L96.4268 195H94.3025L86.4546 205.298H77.2201C76.632 205.298 76.068 205.553 75.6517 206.007C75.2355 206.461 75.0011 207.077 75 207.719C75.0011 208.362 75.2355 208.977 75.6517 209.431C76.068 209.885 76.632 210.14 77.2201 210.14H85.9672L92.2532 224H95.323L92.6439 210.14H108.543C109.041 210.138 109.523 209.954 109.913 209.616C110.303 209.279 110.577 208.808 110.692 208.279L113 201.967Z",
    fill: "#81C394"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3694_4372)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.9941 463.525C43.9941 467.656 67.5933 471.005 116.64 471.005C165.687 471.005 313.001 466.326 313.001 462.214C313.001 458.103 165.694 456.051 116.64 456.051C67.5867 456.051 43.9941 459.4 43.9941 463.525Z",
    fill: "#2A3756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.789 425.91C194.475 452.604 169.965 466.816 130.447 466.816C79.6309 466.816 68.3865 454.515 58.6849 425.91C50.2067 400.908 54.6353 322.259 79.6309 314.798C101.388 308.3 115.08 380.205 130.24 380.205C169.759 380.205 208.472 401.577 201.789 425.91Z",
    fill: "#35476A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.872 278.231C127.305 278.411 133.556 284.127 132.997 290.411C132.438 296.695 130.537 307.391 126.407 307.631C124.579 307.732 118.388 305.305 118.388 305.305L117.69 312.799L106.033 309.456L110.867 299.83C110.867 299.83 103.978 277.636 121.872 278.231Z",
    fill: "#2A3756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.619 287.15C122.039 290.853 121.726 297.304 120.45 291.281C119.825 288.333 117.584 288.413 115.915 290.165C113.86 292.324 116.227 295.359 115.702 296.134C115.177 296.91 111.553 299.898 110.868 299.798C110.183 299.698 106.732 287.096 111.632 280.806C116.999 273.88 130.384 277.216 131.514 284.409C130.397 284.061 127.172 283.48 124.619 287.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.265 391.135C160.766 393.381 163.433 398.729 179.451 405.662C187.431 409.124 193.269 411.417 200.065 413.791L208.044 403.308C195.59 394.879 166.232 375.077 161.125 371.708C153.891 366.928 124.686 394.986 124.686 394.986C124.686 394.986 107.504 395.721 103.255 406.925C102.43 409.098 122.977 410.528 139.062 405.227C146.204 402.86 154.875 390.44 156.265 391.135Z",
    fill: "#D9DADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.715 411.92L206.795 423.231L204.508 415.851L214.702 408.711L231.764 408.851L232.715 411.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.506 415.848L214.035 409.176L206.508 405.266L200.557 413.087L204.506 415.848Z",
    fill: "#2A3756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.307 412.406C105.621 429.787 146.716 403.214 149.841 407.171C152.966 411.129 151.975 418.088 157.155 427.12C161.524 434.707 170.281 447.77 175.402 452.81L186.932 446.225C179.238 433.27 164.616 395.419 161.424 390.185C156.903 382.764 119.326 394.43 119.326 394.43C119.326 394.43 103.627 387.471 95.0354 395.767C92.6482 398.127 97.1899 409.772 98.307 412.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.998 456.809L181.559 466.81L179.631 459.329L190.164 452.711L207.2 453.7L207.998 456.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.94 458.508L188.374 453.835L185.149 447.25L176.877 451.97L180.94 458.508Z",
    fill: "#2A3756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.186 318.049C123.554 318.717 125.409 336.473 117.337 368.935L148.117 379.965L142.97 385.26C142.97 385.26 109.257 387.807 104.011 376.061C98.7644 364.316 102.601 316.879 116.186 318.049Z",
    fill: "#D37B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.767 378.1C159.296 378.247 162.893 380.661 162.807 383.488C162.786 384.111 162.592 384.715 162.248 385.233L147.506 385.661C146.8 384.952 146.403 383.99 146.402 382.987C146.489 380.132 150.239 377.96 154.767 378.1Z",
    fill: "#2A3756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 308.433C103.658 308.767 100.653 313.861 97.1883 324.083C92.241 338.155 88.6636 356.505 91.9618 405.232L136.035 390.459C131.513 366.606 126.726 319.724 118.746 312.17C116.04 309.596 113.619 308.152 109.044 308.433Z",
    fill: "#E2857E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.928 319.752C115.296 320.42 117.151 338.176 109.079 370.638L134.413 379.188L134.713 386.963C134.713 386.963 101 389.517 95.7531 377.771C90.5066 366.026 94.3434 318.582 107.928 319.752Z",
    fill: "#E2857E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.51 379.812C151.038 379.959 154.635 382.365 154.549 385.2C154.522 385.821 154.329 386.424 153.99 386.945L139.248 387.373C138.544 386.663 138.147 385.701 138.145 384.698C138.231 381.844 141.981 379.665 146.51 379.812Z",
    fill: "#2A3756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.52 381.141L141.097 382.839L140.525 387.324L134.414 387.511L134.52 381.141Z",
    fill: "#2A3756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.92 388.129H149.941L166.798 361.355H190.77L173.92 388.129Z",
    fill: "#EBECED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.02 388.127H126.754V386.563L159.257 385.801L158.02 388.127Z",
    fill: "#EBECED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8301 380.973C65.8301 380.973 101.518 391.074 113.56 399.102C119.359 402.966 130.184 407.9 138.164 411.303C141.748 412.827 150.326 411.563 150.326 411.563L153.71 419.405L101.179 444.808L65.8301 380.973Z",
    fill: "#35476A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8652 385.634C72.8652 385.634 93.8045 382.686 116.446 399.178C139.088 415.67 149.947 410.543 149.947 410.543C149.947 410.543 135.983 420.958 115.043 405.649C93.6516 389.993 72.8652 385.634 72.8652 385.634Z",
    fill: "#4F638A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.728 462.181L272.991 350.521H256.214L242.463 462.208L239.178 462.181L253.328 347.238H275.87L290.02 462.181H286.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.36 380.934H249.836V384.216H279.36V380.934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.234 324.465H262.969V349.293H266.234V324.465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.358 286.184H248.853L242.203 331.207C242.203 332.157 252.231 332.925 264.592 332.925C276.954 332.925 286.988 332.157 286.988 331.207L280.358 286.184Z",
    fill: "#2A3756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.357 286.186C280.357 287.136 273.508 287.971 264.598 287.971C255.687 287.971 248.852 287.136 248.852 286.186C248.852 285.237 255.694 284.535 264.598 284.535C273.501 284.535 280.357 285.237 280.357 286.186Z",
    fill: "#1D273F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3694_4372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 269,
    height: 194,
    fill: "white",
    transform: "translate(44 277)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupImgResponsive);
export default __webpack_public_path__ + "static/media/signup_img_responsive.2ca6e277f96de50f4d0354dcbeaefbfe.svg";
export { ForwardRef as ReactComponent };